module.exports = __webpack_public_path__ + "media/ury/bghead-b0a3f8f7.png";